import { memo } from 'react';
import { ContextMenu } from '@components/MainStage/ContextMenu/ContextMenu';
import useShowHideUiItem from '@components/MainStage/ContextMenu/useShowHideUiItem';
import { ContextMenuProps } from '@components/MainStage/types';

const CanvasContextMenu = ({ isOpen, onClose, menu }: ContextMenuProps) => {
  const menuItems = useShowHideUiItem(onClose);

  if (!isOpen || !menu || menu.type !== 'canvas') return null;
  if (menuItems.length === 0) return null;

  return <ContextMenu menuItems={menuItems} {...menu} />;
};

export default memo(CanvasContextMenu);
